import { RefObject } from "react";

import { TextAreaRef } from "antd/lib/input/TextArea";
import { useHotkeys } from "react-hotkeys-hook";

type HotkeyHandler = (event?: KeyboardEvent) => void | PromiseLike<void>;

function hotkeyEventWrapper(handler: HotkeyHandler, inputRef: RefObject<TextAreaRef>): (event: KeyboardEvent) => void {
    return (event: KeyboardEvent) => {
        if (inputRef?.current?.resizableTextArea?.textArea.contains(event.target as Node)) {
            event.preventDefault();
            handler(event);
        }
    };
}

export function useInputHotkey(
    inputRef: RefObject<TextAreaRef>,
    hotKey: string,
    handler: HotkeyHandler
): ReturnType<typeof useHotkeys> {
    return useHotkeys(hotKey, hotkeyEventWrapper(handler, inputRef), { enableOnTags: ["TEXTAREA"] });
}
